import React from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { useAuth } from '../providers';
import { Text, H1 } from '../../../components/atoms';
import { Button } from '../../../components/molecules';
import { CenteredLayout } from '../../../components/templates/CenteredLayout';
import { ReactComponent as Logo } from '../../../assets/images/logo.svg';

const StyledH1 = styled(H1)`
  margin: 16px auto 40px;
`;

const StyledButton = styled(Button)`
  width: 320px;
  margin-bottom: 20px;
  label {
    font-weight: 600;
  }
`;

const StyledText = styled(Text)`
  margin-top: 20px;
  margin-bottom: 30px;
`;

const StyledCenteredLayout = styled(CenteredLayout)`
  background-color: var(--background-light);
`;

const Login = () => {
  const { loginWithGoogle } = useAuth();
  const { loginWithMicrosoft } = useAuth();
  const [searchParams] = useSearchParams();

  const error = searchParams.get('error');
  const description = searchParams.get('description');

  return (
    <StyledCenteredLayout>
      <Logo width={96} height={96} />
      <StyledH1>Welcome to Supper</StyledH1>
      <StyledButton tertiary block onClick={loginWithGoogle}>
        Sign in with Google
      </StyledButton>
      <StyledButton tertiary block onClick={loginWithMicrosoft}>
        Sign in with Microsoft
      </StyledButton>
      {error && (
        <StyledText $color='var(--access-red)'>
          {error === 'unauthorized'
            ? 'You do not have permissions to create an account.'
            : description}
        </StyledText>
      )}
    </StyledCenteredLayout>
  );
};

export { Login };
